import React from "react";
import Lottie from "lottie-react";
import loading from "../img/loading.json";

export const isValidEmail = function (string) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    string
  );
};

export const isValidPassword = (pw) =>
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,20}$/.test(pw);

export const LoadingElement = React.memo(({}) => {
  return (
    <div className="column-center">
      <Lottie
        animationData={loading}
        style={{ width: 250, height: 100 }}
        loop={true}
      />
    </div>
  );
});

export const toE164Kr = (raw) => {
  const only = String(raw || "").replace(/\D/g, "");
  if (!only) return "";
  if (only.startsWith("0")) return "+82" + only.slice(1);
  if (only.startsWith("82")) return "+" + only;
  if (raw.startsWith("+")) return raw;
  return "+" + only;
};

export const strToHtml = (str) =>
  str.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      {str.split("\n").length !== index ? <br /> : ""}
    </span>
  ));
